import type { PaletteMode } from "@mui/material/styles";
import { setOptions } from "@mobiscroll/react";
import {
  SCHEDULE_HOLIDAY_BG_DARK,
  SCHEDULE_HOLIDAY_BG_LIGHT,
  SCHEDULE_HOLIDAY_BORDER_LIGHT,
  SCHEDULE_HOLIDAY_TEXT_DARK,
  SCHEDULE_HOLIDAY_TEXT_LIGHT
} from "../components/Schedule/ScheduleCalendar/functions/schedule-calendar-colors";
import { toValidMuiColor } from "../utils/theme-color.utils";
import { MOBISCROLL_THEME_SURFACES } from "./mobiscroll-theme.tokens";

const CSS_VAR_ACCENT = "--seedit-mbsc-accent";
const CSS_VAR_SURFACE = "--seedit-mbsc-surface";
const CSS_VAR_SURFACE_ELEVATED = "--seedit-mbsc-surface-elevated";
const CSS_VAR_BORDER = "--seedit-mbsc-border";
const CSS_VAR_TEXT = "--seedit-mbsc-text";
const CSS_VAR_TEXT_SECONDARY = "--seedit-mbsc-text-secondary";
const CSS_VAR_SCHEDULE_HOLIDAY_BG = "--seedit-schedule-holiday-bg";
const CSS_VAR_SCHEDULE_HOLIDAY_BORDER = "--seedit-schedule-holiday-border";
const CSS_VAR_SCHEDULE_HOLIDAY_TEXT = "--seedit-schedule-holiday-text";

/** Sync Mobiscroll CSS custom properties from the active MUI theme (tenant brand + mode). */
export function syncMobiscrollCssVars(colorMode: PaletteMode, brandColor: string): void {
  const root = document.documentElement;
  const surfaces = MOBISCROLL_THEME_SURFACES[colorMode];
  const accent = toValidMuiColor(brandColor);

  root.dataset.mobiscrollColorMode = colorMode;
  root.style.setProperty(CSS_VAR_ACCENT, accent);
  root.style.setProperty(CSS_VAR_SURFACE, surfaces.surface);
  root.style.setProperty(CSS_VAR_SURFACE_ELEVATED, surfaces.elevated);
  root.style.setProperty(CSS_VAR_BORDER, surfaces.border);
  root.style.setProperty(CSS_VAR_TEXT, surfaces.text);
  root.style.setProperty(CSS_VAR_TEXT_SECONDARY, surfaces.textSecondary);
  root.style.setProperty(
    CSS_VAR_SCHEDULE_HOLIDAY_BG,
    colorMode === "light" ? SCHEDULE_HOLIDAY_BG_LIGHT : SCHEDULE_HOLIDAY_BG_DARK
  );
  root.style.setProperty(
    CSS_VAR_SCHEDULE_HOLIDAY_BORDER,
    colorMode === "light" ? SCHEDULE_HOLIDAY_BORDER_LIGHT : "transparent"
  );
  root.style.setProperty(
    CSS_VAR_SCHEDULE_HOLIDAY_TEXT,
    colorMode === "light" ? SCHEDULE_HOLIDAY_TEXT_LIGHT : SCHEDULE_HOLIDAY_TEXT_DARK
  );
}

/** Global Mobiscroll theme (material) + runtime CSS variables for accent and surfaces. */
export function configureMobiscrollTheme(colorMode: PaletteMode, brandColor: string): void {
  setOptions({
    theme: "material",
    themeVariant: colorMode
  });
  syncMobiscrollCssVars(colorMode, brandColor);
}
